/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import List from '@nmx/template/dist/componentLibrary/components/List';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export const TypographyStyled = styled(Typography)`
  padding-bottom: ${rem(24)};
`;

export const ListStyled = styled(List)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      display: inline-block;
      .link-list__item {
        display: ${mediumUp ? 'inline-block' : 'block'};
        margin: ${rem(8)};
        &:not(:last-child) {
          padding-right: ${mediumUp ? rem(16) : 0};
          border-right: ${mediumUp ? `${rem(1)} solid ${theme.colors.neutral.gray}` : 'none'};
        }
      }
    `;
  }}
`;
